import {renderTotalPrice} from "./payment/payment";
import {apiCreditsAddToCart} from "../utils/purchase-tracking";
import {getPrice, formatPrice} from "../utils/currency";
import state from "./payment/PaymentState.js";

const SUBS_DURATION_MONTHLY = "monthly";
const SUBS_DURATION_YEARLY = "yearly";

const API_PRICING = "api";
const VEHICLE_PRICING = "vehicle";

const PRICE_SELECTOR = ".js-creditsPrice";
const AMOUNT_SELECTOR = ".js-amount";

const VEHICLE_MARKET_VALUE_CREDITS = "vehicleMarketValueCredits";
const STOLEN_CHECK_CREDITS = "stolenCheckCredits";
const OEM_VIN_LOOKUP_CREDITS = "oemVinLookupCredits";
const VIN_DECODE_CREDITS = "vinDecodeCredits";
const MEMBERSHIP = "membershipSubscription";
const CREDIT_PACKAGE = "creditPack";

const creditInputs = {};
creditInputs[VEHICLE_MARKET_VALUE_CREDITS] = "#creditsVehicleMarketValue";
creditInputs[STOLEN_CHECK_CREDITS] = "#creditsStolen";
creditInputs[OEM_VIN_LOOKUP_CREDITS] = "#creditsOemVinLookup";
creditInputs[VIN_DECODE_CREDITS] = "#creditsDecode";

const summaryInputs = {};
summaryInputs[VEHICLE_MARKET_VALUE_CREDITS] = ".js-pricingVehicleMarketValuePrice";
summaryInputs[STOLEN_CHECK_CREDITS] = ".js-pricingStolenCheckPrice";
summaryInputs[OEM_VIN_LOOKUP_CREDITS] = ".js-pricingOemVinLookupPrice";
summaryInputs[VIN_DECODE_CREDITS] = ".js-pricingVinDecodePrice";
summaryInputs[MEMBERSHIP] = ".js-pricingMembership";
summaryInputs[CREDIT_PACKAGE] = ".js-pricingCreditPack";

const statePricesKeyMap = {};
statePricesKeyMap[VEHICLE_MARKET_VALUE_CREDITS] = "creditsVehicleMarketValue";
statePricesKeyMap[STOLEN_CHECK_CREDITS] = "creditsStolen";
statePricesKeyMap[OEM_VIN_LOOKUP_CREDITS] = "creditsOemVinLookup";
statePricesKeyMap[VIN_DECODE_CREDITS] = "creditsDecode";

state.creditsSelected = {
  creditsDecode: 0,
  creditsVehicleMarketValue: 0,
  creditsStolen: 0,
  creditsOemVinLookup: 0,
  creditsWeb: 0
};

const DECODE_HREF = "decode";
let firstRender = true;

// Period tabs code
$('input[type=radio][name=subscriptionSwitch]').on('change', function (e) {
  e.preventDefault();
  changeSubsDurationTable($(this).val(), ($(this).attr("id").includes("api")) ? API_PRICING : VEHICLE_PRICING, e);
});

function changeSubsDurationTable(duration, type, e) {
  let monthlyClassSelector = "";
  let yearlylClassSelector = "";

  if (type === API_PRICING) {
    monthlyClassSelector = ".js-pricingApiMonthly";
    yearlylClassSelector = ".js-pricingApiYearly";
  }

  if (type === VEHICLE_PRICING) {
    monthlyClassSelector = ".js-pricingVehicleMonthly";
    yearlylClassSelector = ".js-pricingVehicleYearly";
  }

  if (duration === SUBS_DURATION_MONTHLY) {
    crossfadeTable(monthlyClassSelector, yearlylClassSelector);
  }

  if (duration === SUBS_DURATION_YEARLY) {
    crossfadeTable(yearlylClassSelector, monthlyClassSelector);
  }
}

function crossfadeTable(fadeIn, fadeOut) {
  $(fadeOut).css({position: "absolute"});
  $(fadeOut).fadeOut(400, () => {
  });
  $(fadeIn).fadeIn(400, () => $(fadeOut).css({position: "relative"}));
}

// Open sample record code
$('.js-pricingSampleReportBtn').click(() => {
  const sampleReport = $(".js-pricingSampleReport");
  document.querySelector(".js-pricingSampleReportBtn").classList.toggle("is-open");
  sampleReport.fadeToggle(400);
});

// Pricing tabs
const PRICING_TABS_WRAPPER = "js-pricingTabs";
const PRICING_TABS_LINK = "js-pricingTabLink";
const PRICING_TABS_CONTENT = "js-pricingTabContent";
$(`.${PRICING_TABS_LINK}`).click(function (e) {
  e.preventDefault();
  handleTabs(PRICING_TABS_WRAPPER, PRICING_TABS_LINK, PRICING_TABS_CONTENT, this);
});

// Section tabs
const SECTION_TABS_WRAPPER = "js-pricingSectionsTabs";
const SECTION_TABS_LINK = "js-pricingSectionTabLink";
const SECTION_TABS_CONTENT = "js-pricingSectionsTabContent";
$(`.${SECTION_TABS_LINK}`).click(function (e) {
  e.preventDefault();
  handleTabs(SECTION_TABS_WRAPPER, SECTION_TABS_LINK, SECTION_TABS_CONTENT, this);
});

function handleTabs(wrapperClass, linkClass, contentClass, target) {
  const tab_id = $(target).attr('data-tab');
  const parent = $(target).closest(`.${wrapperClass}`);

  parent.find(`.${linkClass}`).removeClass('current');
  parent.find(`.${contentClass}`).removeClass('current');
  $(target).addClass('current');
  parent.find("#" + tab_id).addClass('current');

  if (!firstRender) {
    if (tab_id !== DECODE_HREF) {
      history.pushState({}, null, `#${tab_id}`);
    } else {
      history.pushState({}, document.title, `${window.location.pathname}${window.location.search}`);
    }
  } else {
    firstRender = false;
  }
}

const buyNowBtn = $(".js-submitPricingPrepay");
// Here comes the pricing
$(".js-valuePricingPrepay").on("input", function () {
  // If value is not whole number
  if (/\D/g.test(this.value) || this.value.length === 0 || this.value < 1) {
    buyNowBtn.attr("disabled", true).addClass("is-disabled");
    this.value = this.value.replace(/\D/g, "");
    if (this.value.length === 0) {
      $(this).parent().find(".js-pricingPrepayPrice").html("");
    }
  } else {
    buyNowBtn.removeAttr("disabled").removeClass("is-disabled");
    const pricePerReport = state.prices[statePricesKeyMap[this.id]];
    const creditsPrice = parseFloat(pricePerReport) * parseFloat(this.value);
    $(this).parent().find(".js-pricingPrepayPrice").html(formatPrice(creditsPrice, state.currencyCode, true));
  }
});

// Handle membership btn
// TODO fixme
$(".js-selectPricingTier").click((e) => {
  $(".js-selectPricingTier").removeClass("is-active");
  const btn = $(e.target).closest(".js-selectPricingTier");
  btn.addClass("is-active");

  setMembershipPrice(btn.data("pricing-tier-price"), MEMBERSHIP);
  scrollToCheckout();
});

// Handle Credit Package btn
$(".js-selectCreditPackage").click((e) => {
  $(".js-selectCreditPackage").removeClass("is-active");
  const btn = $(e.target).closest(".js-selectCreditPackage");
  const packagePrice = btn.data("pricing-package-price");
  btn.addClass("is-active");

  if (packagePrice > 0) {
    setCreditPackPrice(packagePrice, CREDIT_PACKAGE, btn.data("credit-amount"), btn.data("credit-type"), btn.data("credit-label"));
    scrollToCheckout();
    apiCreditsAddToCart(btn.data("pricing-package-price"), btn.data("currency-code"), btn.data("credit-label"), btn.data("credit-amount"));
  }
});

// Handle pre-pay btn
$(".js-submitPricingPrepay").click((e) => {
  const targetParent = $(e.target).parent();
  const creditType = targetParent.find(".js-valuePricingPrepay").attr('id');
  const value = targetParent.find(".js-valuePricingPrepay").val();

  state.creditsSelected[statePricesKeyMap[creditType]] = isNaN(parseInt(value)) ? 0 : parseInt(value);
  const price = state.prices[statePricesKeyMap[creditType]] * state.creditsSelected[statePricesKeyMap[creditType]];

  setPrice(parseFloat(price), creditType);
  scrollToCheckout();
});

function setPrice(price, creditType) {
  const priceSummaryEl = $(summaryInputs[creditType]);
  priceSummaryEl.removeClass("u-isHidden");
  priceSummaryEl.find(PRICE_SELECTOR).html(getPrice(price, state.currencyCode));
  priceSummaryEl.find(AMOUNT_SELECTOR).html(`(${state.creditsSelected[statePricesKeyMap[creditType]]}x)`);
  renderTotalPrice({priceSum: true});
}

function setCreditPackPrice(price, packageType, amount = 0, creditType = null, label = "") {
  const priceSummaryEl = $(summaryInputs[packageType]);
  priceSummaryEl.removeClass("u-isHidden");
  if (amount > 0) {
    priceSummaryEl.find(AMOUNT_SELECTOR).html(`(${label})`);
    state.creditPacksSelected[statePricesKeyMap[creditType]] = {price, amount};
    $(summaryInputs[creditType]).addClass("u-isHidden");
  }

  priceSummaryEl.find(PRICE_SELECTOR).html(getPrice(price, state.currencyCode));
  renderTotalPrice();
}

// TODO FIX ME NOT WORKING AT ALL PROBABLY RIGHT NOW
function setMembershipPrice(price, membershipType, amount = 0, creditType = null) {
  const priceSummaryEl = $(summaryInputs[membershipType]);
  resetSummaryPrices();
  resetInputsAmount();
  priceSummaryEl.removeClass("u-isHidden");
  if (amount > 0) {
    priceSummaryEl.find(AMOUNT_SELECTOR).html(`(${amount})`);
    setInputAmount(amount, creditType);
    state.creditsSelected[creditType] = amount;
  }

  priceSummaryEl.find(PRICE_SELECTOR).html(getPrice(price, state.currencyCode));
  renderTotalPrice({price});
}

function scrollToCheckout() {
  const checkoutForm = $(".js-pricingCheckoutForm");
  if (checkoutForm.css("display") === "none") {
    checkoutForm.fadeIn(400);
  }

  $("html, body").animate({scrollTop: $('.js-pricingCheckoutForm').offset().top}, 1000);
}

function setInputAmount(amount, creditType) {
  $(creditInputs[creditType]).val(amount);
}

function resetSummaryPrices() {
  Object.keys(summaryInputs).forEach(key => {
    $(summaryInputs[key]).addClass("u-isHidden");
  });
}

function resetInputsAmount() {
  Object.keys(creditInputs).forEach(key => {
    $(creditInputs[key]).val(0);
  });
}

function handleIncompletePayment() {
  if (sessionStorage.getItem('paymentInProgress') === 'true') {
    if (document.querySelector(".is-erroneous") !== null) {
      scrollToCheckout();
    } else {
      sessionStorage.setItem('paymentInProgress', 'false')
    }
  }
}

$(document).ready(function () {
  handleIncompletePayment();
  // Handle initial state based on hashtag value
  const parsedUrl = window.location.href.split("#");
  if (parsedUrl.length > 1) {
    $(document).find(`[data-tab='${parsedUrl[1]}']`).trigger("click");
  } else {
    firstRender = false;
  }
  if (parsedUrl.length > 2) {
    $(document).find(`[data-tab='${parsedUrl[2]}']`).trigger("click");
  }
});

$(window).on("popstate", function () {
  handleIncompletePayment();
});
